import React, { FC } from 'react';
import { useScopedSelector, injectTranslations } from 'ia-react-core';
import { ApplicationWarnings } from 'omni-package-react-core';
import { Helmet } from 'react-helmet';
import { StyledTitle, StyledInstabilityMessages } from './LoginPage.styles';
import SignIn from './SignIn';
import { CONTROLLER_NAME_LOGIN } from './LoginUtils';
import LoginPageState from './interfaces/LoginPageState';
import LangueFr from './translations/fr';
import LangueEn from './translations/en';
import InformativeMessage from '../../components/InformativeMessage';
export interface LoginPageProps {
  titleCustomEn: string;
  titleCustomFr: string;
  mobileDeviceMode: Boolean;
  showInstabilityMessages?: boolean;
  showUnavailabilityWarning?: boolean;
  disableSignUp?: boolean;
}

const LoginPage: FC<LoginPageProps> = ({ titleCustomEn, titleCustomFr, mobileDeviceMode, showInstabilityMessages = true, showUnavailabilityWarning = false, disableSignUp = false }) => {
  const needReInject = titleCustomEn || titleCustomFr;
  if (titleCustomEn) {
    LangueEn.widgetTitleConnexion = titleCustomEn;
  }
  if (titleCustomFr) {
    LangueFr.widgetTitleConnexion = titleCustomFr;
  }

  if (needReInject) {
    injectTranslations('LoginPage', [
      { language: 'fr', resource: LangueFr },
      { language: 'en', resource: LangueEn },
    ]);
  }

  const { code, title } = useScopedSelector((state: LoginPageState) => state);

  return (
    <>
      <Helmet><title>{title}</title></Helmet>
      <div>
        {code === CONTROLLER_NAME_LOGIN && !mobileDeviceMode ?
          <StyledInstabilityMessages>
            <ApplicationWarnings showInstabilityMessages={showInstabilityMessages} showUnavailabilityWarning={showUnavailabilityWarning} />
          </StyledInstabilityMessages> : null}
        {!mobileDeviceMode ? <StyledTitle>{title}</StyledTitle> : null}
        {code === CONTROLLER_NAME_LOGIN ? <InformativeMessage mobileDeviceMode={false} /> : null}
        <SignIn code={code} disableSignUp={disableSignUp} />
      </div>
    </>
  );
};

export default LoginPage;
